var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
import { useCallback, useEffect } from "react";
function ClickOutsideListener(_ref) {
  var onClickOutside = _ref.onClickOutside;
  var handleClickOutside = useCallback(onClickOutside, [onClickOutside]);
  useEffect(function() {
    document.addEventListener("click", handleClickOutside, {
      capture: true
    });
    return function() {
      document.removeEventListener("click", handleClickOutside, {
        capture: true
      });
    };
  });
  return null;
}
__name(ClickOutsideListener, "ClickOutsideListener");
export {
  ClickOutsideListener
};
